import type { ApiRoute, NoQueryParams, NoResponse } from "../../api"
import type { PutPurchaseRequestVisibilityBody } from "./PutPurchaseRequestVisibilityBody"

export interface PutPurchaseRequestVisibilityPathParams {
	purchaseRequestId: string
}

export const putPurchaseRequestVisibilityRoute: ApiRoute<
	PutPurchaseRequestVisibilityPathParams,
	NoQueryParams,
	PutPurchaseRequestVisibilityBody,
	NoResponse
> = {
	buildUrl: ({ purchaseRequestId }: PutPurchaseRequestVisibilityPathParams) =>
		`/purchase-requests-v2/${purchaseRequestId}/visibility`,
	method: "put",
	path: "/purchase-requests-v2/:purchaseRequestId/visibility",
}
